import React from "react";
import AccountSetting from "../components/account_setting_side_bar/AccountSetting";
import ChangePassword from "../components/change_password/ChangePassword";
import HelpCenter from "../components/user_help_center/HelpCenter";
import LegalNotice from "../components/user_legal_notice/LegalNotice";
import UserProfile from "../components/user_profile/UserProfile";
import UserAddress from "../components/user_address/UserAddress";
import UserNotification from "../components/user_notfication/UserNotification";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import UserWishlist from "../components/user_wishlist/UserWishlist";
import OrderList from "../components/order_list/OrderList";

export default function UserSetting() {
  return (
    // <ChangePassword />
    // <HelpCenter />
    <>
      {/* <LegalNotice /> */}
      {/* <UserWishlist /> */}

      <Header />
      {/* <Container className="py-5">
        <Row>
          <Col lg={3} className="my-4">
            <AccountSetting />
       
          </Col>
          <Col lg={9} className="my-3">
            <OrderList />
          </Col>
        </Row>
      </Container> */}
      <Tab.Container id="left-tabs-example" defaultActiveKey="account" >
        <Row className=" pb-4 pt-4 user-setting pt-5 mt-4">
          <Col lg={3} className="px-4 p-5">
            <Nav variant="pills" className="flex-column">
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="account">
                  <svg style={{paddingRight: "4px"}}
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.2883 11.2906C21.2883 5.81901 16.8605 1.39062 11.3883 1.39062C5.91666 1.39062 1.48828 5.81841 1.48828 11.2906C1.48828 16.7137 5.87905 21.1906 11.3883 21.1906C16.8749 21.1906 21.2883 16.7387 21.2883 11.2906ZM11.3883 2.55078C16.2075 2.55078 20.1281 6.47145 20.1281 11.2906C20.1281 13.0535 19.6038 14.748 18.6314 16.1832C14.7268 11.9831 8.05691 11.9755 4.14516 16.1832C3.17277 14.748 2.64843 13.0535 2.64843 11.2906C2.64843 6.47145 6.5691 2.55078 11.3883 2.55078ZM4.86874 17.1107C8.34045 13.2166 14.437 13.2176 17.9077 17.1107C14.4243 21.0078 8.35359 21.009 4.86874 17.1107Z"
                      fill="#777777"
                      stroke="#777777"
                      stroke-width="0.2"
                    />
                    <path
                      d="M11.3867 11.8711C13.3058 11.8711 14.8672 10.3097 14.8672 8.39063V7.23047C14.8672 5.31138 13.3058 3.75 11.3867 3.75C9.46763 3.75 7.90625 5.31138 7.90625 7.23047V8.39063C7.90625 10.3097 9.46763 11.8711 11.3867 11.8711ZM9.06641 7.23047C9.06641 5.95098 10.1072 4.91016 11.3867 4.91016C12.6662 4.91016 13.707 5.95098 13.707 7.23047V8.39063C13.707 9.67012 12.6662 10.7109 11.3867 10.7109C10.1072 10.7109 9.06641 9.67012 9.06641 8.39063V7.23047Z"
                      fill="#777777"
                      stroke="#777777"
                      stroke-width="0.2"
                    />
                  </svg>
                  Account Settings
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="order">
                  {" "}
                  <i className="fa fa-shopping-bag" style={{paddingRight: "4px"}} aria-hidden="true"></i>{" "}
                  Orders
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="wishlist">
                  <svg className="pr-4" style={{paddingRight: "4px"}}
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.3883 20.5902C11.1064 20.5902 10.8346 20.4882 10.6228 20.3028C9.82297 19.604 9.0518 18.9474 8.37142 18.3681L8.36794 18.3651C6.37317 16.6667 4.65061 15.2 3.45208 13.7551C2.11231 12.1399 1.48828 10.6085 1.48828 8.93543C1.48828 7.30994 2.04615 5.81032 3.05902 4.71262C4.08397 3.60194 5.49036 2.99023 7.01956 2.99023C8.1625 2.99023 9.20921 3.35125 10.1305 4.06318C10.5955 4.42254 11.017 4.86234 11.3883 5.37535C11.7597 4.86234 12.181 4.42254 12.6462 4.06318C13.5675 3.35125 14.6142 2.99023 15.7571 2.99023C17.2862 2.99023 18.6927 3.60194 19.7177 4.71262C20.7306 5.81032 21.2883 7.30994 21.2883 8.93543C21.2883 10.6085 20.6644 12.1399 19.3246 13.755C18.1261 15.2 16.4037 16.6665 14.4092 18.3648C13.7276 18.9449 12.9552 19.6027 12.1536 20.3031C11.9419 20.4882 11.67 20.5902 11.3883 20.5902ZM7.01956 4.14906C5.81817 4.14906 4.71451 4.6281 3.91161 5.49805C3.09678 6.38113 2.64798 7.60183 2.64798 8.93543C2.64798 10.3425 3.17141 11.6009 4.34501 13.0157C5.47933 14.3833 7.16655 15.8198 9.12008 17.4832L9.1237 17.4862C9.80666 18.0678 10.5808 18.727 11.3866 19.4309C12.1972 18.7256 12.9726 18.0653 13.6569 17.4829C15.6103 15.8195 17.2974 14.3833 18.4317 13.0157C19.6051 11.6009 20.1286 10.3425 20.1286 8.93543C20.1286 7.60183 19.6798 6.38113 18.8649 5.49805C18.0622 4.6281 16.9584 4.14906 15.7571 4.14906C14.8771 4.14906 14.069 4.42857 13.3556 4.97976C12.7197 5.47118 12.2768 6.0924 12.0171 6.52708C11.8836 6.7506 11.6486 6.88402 11.3883 6.88402C11.128 6.88402 10.8929 6.7506 10.7594 6.52708C10.4999 6.0924 10.057 5.47118 9.42099 4.97976C8.70753 4.42857 7.8995 4.14906 7.01956 4.14906Z"
                      fill="#777777"
                      stroke="#777777"
                      stroke-width="0.2"
                    />
                  </svg>
                  Wishlist
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="address">
                  <svg  style={{paddingRight: "4px"}}
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1176_4304)">
                      <path
                        d="M11.3855 0.791016C6.99219 0.791016 3.41797 4.36525 3.41797 8.75854C3.41797 14.2107 10.5481 22.2149 10.8517 22.553C11.1368 22.8706 11.6347 22.87 11.9193 22.553C12.2229 22.2149 19.3531 14.2107 19.3531 8.75854C19.353 4.36525 15.7788 0.791016 11.3855 0.791016ZM11.3855 20.9747C8.98586 18.1242 4.85278 12.5005 4.85278 8.75863C4.85278 5.15639 7.78333 2.22583 11.3855 2.22583C14.9877 2.22583 17.9182 5.15639 17.9182 8.75859C17.9182 12.5006 13.7858 18.1233 11.3855 20.9747Z"
                        fill="#777777"
                      />
                      <path
                        d="M11.3875 4.75C9.17714 4.75 7.37891 6.54829 7.37891 8.75869C7.37891 10.9691 9.17719 12.7674 11.3875 12.7674C13.5978 12.7674 15.3961 10.9691 15.3961 8.75869C15.3961 6.54829 13.5978 4.75 11.3875 4.75ZM11.3875 11.3325C9.96828 11.3325 8.81372 10.1779 8.81372 8.75869C8.81372 7.33943 9.96833 6.18482 11.3875 6.18482C12.8067 6.18482 13.9613 7.33943 13.9613 8.75869C13.9613 10.1779 12.8067 11.3325 11.3875 11.3325Z"
                        fill="#777777"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1176_4304">
                        <rect
                          width="22"
                          height="22"
                          fill="white"
                          transform="translate(0.386719 0.791016)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Address
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="notify">
                  <svg style={{paddingRight: "4px"}}
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1176_4311)">
                      <path
                        d="M20.7668 10.6444C20.3873 10.6444 20.0793 10.3364 20.0793 9.95686C20.0793 7.32419 19.0546 4.85013 17.1936 2.98837C16.9251 2.71982 16.9251 2.28442 17.1936 2.01587C17.4622 1.74731 17.8976 1.74731 18.1663 2.01587C20.2866 4.13695 21.4543 6.95761 21.4543 9.95686C21.4543 10.3364 21.1463 10.6444 20.7668 10.6444Z"
                        fill="#8C969F"
                      />
                      <path
                        d="M1.97656 10.6455C1.59706 10.6455 1.28906 10.3375 1.28906 9.95797C1.28906 6.95872 2.45694 4.13806 4.57802 2.01782C4.84657 1.74927 5.28214 1.74927 5.55069 2.01782C5.81925 2.28637 5.81925 2.72193 5.55069 2.99049C3.68894 4.85124 2.66406 7.3253 2.66406 9.95797C2.66406 10.3375 2.35607 10.6455 1.97656 10.6455Z"
                        fill="#777777"
                      />
                      <path
                        d="M11.3711 22.791C9.47543 22.791 7.93359 21.2492 7.93359 19.3535C7.93359 18.974 8.24159 18.666 8.62109 18.666C9.00059 18.666 9.30859 18.974 9.30859 19.3535C9.30859 20.4912 10.2334 21.416 11.3711 21.416C12.5086 21.416 13.4336 20.4912 13.4336 19.3535C13.4336 18.974 13.7416 18.666 14.1211 18.666C14.5006 18.666 14.8086 18.974 14.8086 19.3535C14.8086 21.2492 13.2668 22.791 11.3711 22.791Z"
                        fill="#777777"
                      />
                      <path
                        d="M18.9363 20.041H3.81131C2.92659 20.041 2.20703 19.3214 2.20703 18.4369C2.20703 17.9674 2.41146 17.523 2.76814 17.2177C4.16227 16.0397 4.95703 14.3275 4.95703 12.5134V9.95763C4.95703 6.41942 7.83543 3.54102 11.3738 3.54102C14.912 3.54102 17.7904 6.41942 17.7904 9.95763V12.5134C17.7904 14.3275 18.5852 16.0397 19.9703 17.2113C20.336 17.523 20.5404 17.9674 20.5404 18.4369C20.5404 19.3214 19.8209 20.041 18.9363 20.041ZM11.3738 4.91602C8.59343 4.91602 6.33203 7.17742 6.33203 9.95763V12.5134C6.33203 14.7325 5.35952 16.8281 3.66461 18.2608C3.63255 18.2883 3.58203 18.3452 3.58203 18.4369C3.58203 18.5614 3.6866 18.666 3.81131 18.666H18.9363C19.0609 18.666 19.1654 18.5614 19.1654 18.4369C19.1654 18.3452 19.1151 18.2883 19.0847 18.2627C17.3879 16.8281 16.4154 14.7325 16.4154 12.5134V9.95763C16.4154 7.17742 14.154 4.91602 11.3738 4.91602Z"
                        fill="#777777"
                      />
                      <path
                        d="M11.3711 4.91602C10.9916 4.91602 10.6836 4.60802 10.6836 4.22852V1.47852C10.6836 1.09901 10.9916 0.791016 11.3711 0.791016C11.7506 0.791016 12.0586 1.09901 12.0586 1.47852V4.22852C12.0586 4.60802 11.7506 4.91602 11.3711 4.91602Z"
                        fill="#777777"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1176_4311">
                        <rect
                          width="22"
                          height="22"
                          fill="white"
                          transform="translate(0.386719 0.791016)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Notifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="legal">
                  <svg style={{paddingRight: "4px"}}
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1176_4321)">
                      <path
                        d="M15.2325 3.58089L15.1452 3.48336V3.61423V6.39322V6.44322H15.1952H17.6816H17.7934L17.7189 6.35988L15.2325 3.58089ZM13.6851 2.35216V2.30216H13.6351H5.52771C4.72798 2.30216 4.07755 2.95259 4.07755 3.75232V19.8313C4.07755 20.631 4.72798 21.2814 5.52771 21.2814H17.246C18.0458 21.2814 18.6962 20.631 18.6964 19.8313V7.95332V7.90332H18.6464H13.6851V2.35216ZM5.52771 0.841797H14.7417L20.1568 6.89422V19.8313C20.1568 21.4363 18.8511 22.7418 17.2465 22.7418H5.52771C3.92293 22.7418 2.61719 21.4361 2.61719 19.8313V3.75232C2.61719 2.14754 3.92293 0.841797 5.52771 0.841797Z"
                        fill="#777777"
                        stroke="white"
                        stroke-width="0.1"
                      />
                      <path
                        d="M5.85156 18.0736V16.6133H16.9203V18.0736H5.85156Z"
                        fill="#777777"
                        stroke="white"
                        stroke-width="0.1"
                      />
                      <path
                        d="M5.85156 14.6831V13.2227H16.9203V14.6831H5.85156Z"
                        fill="#777777"
                        stroke="white"
                        stroke-width="0.1"
                      />
                      <path
                        d="M5.85156 11.2924V9.83203H16.9203V11.2924H5.85156Z"
                        fill="#777777"
                        stroke="white"
                        stroke-width="0.1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1176_4321">
                        <rect
                          width="22"
                          height="22"
                          fill="white"
                          transform="translate(0.386719 0.791016)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Legal Notice
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="helpcenter">
                  <svg style={{paddingRight: "4px"}}
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1176_4330)">
                      <path
                        d="M19.1649 4.01282C17.0872 1.93523 14.3249 0.791016 11.3867 0.791016C8.44852 0.791016 5.68619 1.93523 3.60852 4.01282C1.53093 6.09049 0.386719 8.85282 0.386719 11.791C0.386719 14.7292 1.53093 17.4915 3.60852 19.5692C5.68619 21.6468 8.44852 22.791 11.3867 22.791C14.3249 22.791 17.0872 21.6468 19.1649 19.5692C21.2425 17.4915 22.3867 14.7292 22.3867 11.791C22.3867 8.85282 21.2425 6.09049 19.1649 4.01282ZM11.3867 2.08008C13.8325 2.08008 16.0698 2.98934 17.779 4.48715L14.7793 7.48693C13.8453 6.7492 12.6666 6.30829 11.3867 6.30829C10.1069 6.30829 8.92813 6.7492 7.99421 7.48693L4.99443 4.48715C6.70364 2.98934 8.9409 2.08008 11.3867 2.08008ZM15.5804 11.791C15.5804 14.1034 13.6991 15.9847 11.3867 15.9847C9.07431 15.9847 7.19306 14.1034 7.19306 11.791C7.19306 9.47861 9.07431 7.59736 11.3867 7.59736C13.6991 7.59736 15.5804 9.47861 15.5804 11.791ZM1.67578 11.791C1.67578 9.34515 2.58509 7.1079 4.08293 5.39865L7.08271 8.39842C6.34494 9.33239 5.90399 10.5111 5.90399 11.791C5.90399 13.0709 6.3449 14.2496 7.08263 15.1836L4.08285 18.1834C2.58504 16.4741 1.67578 14.2368 1.67578 11.791ZM11.3867 21.5019C8.94085 21.5019 6.7036 20.5926 4.9943 19.0948L7.99408 16.095C8.92805 16.8328 10.1068 17.2737 11.3867 17.2737C12.6665 17.2737 13.8453 16.8328 14.7793 16.095L17.7791 19.0947C16.0698 20.5926 13.8326 21.5019 11.3867 21.5019ZM18.6906 18.1833L15.6908 15.1835C16.4285 14.2495 16.8694 13.0708 16.8694 11.791C16.8694 10.5111 16.4285 9.33239 15.6908 8.39842L18.6905 5.39865C20.1883 7.1079 21.0976 9.34515 21.0976 11.791C21.0976 14.2368 20.1884 16.4741 18.6906 18.1833Z"
                        fill="#777777"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1176_4330">
                        <rect
                          width="22"
                          height="22"
                          fill="white"
                          transform="translate(0.386719 0.791016)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Help Center
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="password">
                  <svg style={{paddingRight: "4px"}}
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.6576 9.05434C11.0934 8.99861 10.5257 9.11865 10.0323 9.39801C9.53896 9.67737 9.14399 10.1024 8.90151 10.6149C8.65903 11.1274 8.58088 11.7023 8.67778 12.261C8.77467 12.8196 9.04187 13.3347 9.44278 13.7356C9.84369 14.1365 10.3587 14.4037 10.9174 14.5006C11.476 14.5975 12.0509 14.5193 12.5634 14.2768C13.0759 14.0344 13.501 13.6394 13.7803 13.146C14.0597 12.6526 14.1797 12.085 14.124 11.5207C14.0605 10.8882 13.7802 10.2971 13.3307 9.84763C12.8812 9.39813 12.2901 9.11787 11.6576 9.05434V9.05434ZM18.2791 11.791C18.2773 12.0899 18.2554 12.3884 18.2133 12.6843L20.156 14.208C20.2406 14.2781 20.2975 14.376 20.3168 14.4841C20.3361 14.5923 20.3164 14.7038 20.2612 14.7988L18.4235 17.9785C18.3677 18.0726 18.2804 18.144 18.1771 18.1801C18.0738 18.2162 17.9611 18.2146 17.8589 18.1757L15.9296 17.3989C15.8232 17.3565 15.7079 17.3412 15.5942 17.3543C15.4804 17.3674 15.3717 17.4086 15.2777 17.4741C14.9833 17.6768 14.6739 17.8569 14.3522 18.0129C14.251 18.062 14.1636 18.1353 14.0975 18.2263C14.0314 18.3173 13.9887 18.4232 13.9732 18.5345L13.684 20.5923C13.665 20.701 13.6089 20.7997 13.5252 20.8716C13.4415 20.9434 13.3354 20.984 13.2251 20.9863H9.54956C9.44108 20.9845 9.33647 20.9457 9.25298 20.8764C9.16948 20.8071 9.11208 20.7115 9.09022 20.6052L8.80147 18.5504C8.78526 18.4378 8.74147 18.331 8.674 18.2394C8.60653 18.1478 8.51748 18.0742 8.41475 18.0254C8.09344 17.8703 7.78508 17.6896 7.49264 17.4852C7.39901 17.4201 7.29064 17.3793 7.1773 17.3664C7.06396 17.3536 6.94921 17.3692 6.84338 17.4118L4.91452 18.1882C4.8123 18.2271 4.69962 18.2287 4.59634 18.1927C4.49305 18.1567 4.40578 18.0854 4.34991 17.9914L2.51213 14.8117C2.45688 14.7167 2.43714 14.6052 2.45642 14.497C2.47569 14.3888 2.53274 14.291 2.61741 14.2209L4.25924 12.9318C4.34919 12.8604 4.41989 12.7677 4.46491 12.662C4.50993 12.5564 4.52786 12.4412 4.51706 12.3268C4.50159 12.1477 4.49213 11.9689 4.49213 11.7897C4.49213 11.6105 4.50116 11.4344 4.51706 11.2591C4.52667 11.1454 4.50787 11.0312 4.46234 10.9266C4.41681 10.822 4.34598 10.7305 4.25624 10.6601L2.61526 9.37102C2.53197 9.30059 2.47612 9.20309 2.4575 9.09562C2.43888 8.98814 2.45868 8.87755 2.51342 8.7832L4.3512 5.60352C4.40701 5.50941 4.49425 5.43802 4.59754 5.40194C4.70083 5.36586 4.81354 5.3674 4.91581 5.40629L6.8451 6.18316C6.9515 6.22552 7.06674 6.24083 7.1805 6.22771C7.29426 6.21458 7.40299 6.17344 7.49694 6.10797C7.79138 5.90521 8.10079 5.72508 8.42249 5.56914C8.52362 5.51998 8.6111 5.44668 8.6772 5.35571C8.7433 5.26473 8.78598 5.15888 8.80147 5.0475L9.09065 2.98973C9.10964 2.88105 9.16579 2.78234 9.24949 2.71048C9.33319 2.63861 9.43926 2.59804 9.54956 2.5957H13.2251C13.3336 2.59758 13.4382 2.63635 13.5217 2.70563C13.6052 2.77491 13.6626 2.87057 13.6844 2.97684L13.9732 5.0316C13.9894 5.14421 14.0332 5.25106 14.1007 5.34267C14.1681 5.43427 14.2572 5.50779 14.3599 5.55668C14.6812 5.71178 14.9896 5.8924 15.282 6.0968C15.3756 6.16194 15.484 6.20277 15.5974 6.2156C15.7107 6.22842 15.8255 6.21285 15.9313 6.17027L17.8601 5.39383C17.9624 5.3549 18.075 5.3533 18.1783 5.3893C18.2816 5.4253 18.3689 5.49659 18.4248 5.59062L20.2625 8.77031C20.3178 8.86531 20.3375 8.97684 20.3182 9.08503C20.299 9.19322 20.2419 9.29106 20.1573 9.36113L18.5154 10.6502C18.4251 10.7214 18.354 10.814 18.3086 10.9197C18.2632 11.0253 18.2449 11.1407 18.2555 11.2552C18.2696 11.4331 18.2791 11.6118 18.2791 11.791Z"
                      stroke="#777777"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Change Password
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="mb-2">
                <Nav.Link eventKey="logout">
                  <svg style={{paddingRight: "4px"}}
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1176_4342)">
                      <path
                        d="M17.5742 22.791H5.19922C4.06255 22.791 3.13672 21.8661 3.13672 20.7285V11.1035C3.13672 9.96594 4.06255 9.04102 5.19922 9.04102H17.5742C18.7109 9.04102 19.6367 9.96594 19.6367 11.1035V20.7285C19.6367 21.8661 18.7109 22.791 17.5742 22.791ZM5.19922 10.416C4.82064 10.416 4.51172 10.724 4.51172 11.1035V20.7285C4.51172 21.108 4.82064 21.416 5.19922 21.416H17.5742C17.9528 21.416 18.2617 21.108 18.2617 20.7285V11.1035C18.2617 10.724 17.9528 10.416 17.5742 10.416H5.19922Z"
                        fill="#777777"
                      />
                      <path
                        d="M16.1992 10.416C15.8197 10.416 15.5117 10.108 15.5117 9.72852V6.29102C15.5117 4.01677 13.661 2.16602 11.3867 2.16602C9.11247 2.16602 7.26172 4.01677 7.26172 6.29102V9.72852C7.26172 10.108 6.95372 10.416 6.57422 10.416C6.19472 10.416 5.88672 10.108 5.88672 9.72852V6.29102C5.88672 3.25777 8.35347 0.791016 11.3867 0.791016C14.4199 0.791016 16.8867 3.25777 16.8867 6.29102V9.72852C16.8867 10.108 16.5787 10.416 16.1992 10.416Z"
                        fill="#777777"
                      />
                      <path
                        d="M11.388 16.3757C10.3769 16.3757 9.55469 15.5534 9.55469 14.5423C9.55469 13.5312 10.3769 12.709 11.388 12.709C12.3991 12.709 13.2214 13.5312 13.2214 14.5423C13.2214 15.5534 12.3991 16.3757 11.388 16.3757ZM11.388 14.084C11.136 14.084 10.9297 14.2893 10.9297 14.5423C10.9297 14.7953 11.136 15.0007 11.388 15.0007C11.6401 15.0007 11.8464 14.7953 11.8464 14.5423C11.8464 14.2893 11.6401 14.084 11.388 14.084Z"
                        fill="#777777"
                      />
                      <path
                        d="M11.3867 19.1243C11.0072 19.1243 10.6992 18.8163 10.6992 18.4368V15.916C10.6992 15.5365 11.0072 15.2285 11.3867 15.2285C11.7662 15.2285 12.0742 15.5365 12.0742 15.916V18.4368C12.0742 18.8163 11.7662 19.1243 11.3867 19.1243Z"
                        fill="#777777"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1176_4342">
                        <rect
                          width="22"
                          height="22"
                          fill="white"
                          transform="translate(0.386719 0.791016)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Logout
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col lg={9} className="p-lg-5 p-md-0">
            <Tab.Content>
              <Tab.Pane eventKey="account">
                <UserProfile />
              </Tab.Pane>
              <Tab.Pane eventKey="order">
                <OrderList />
              </Tab.Pane>
              <Tab.Pane eventKey="wishlist">
                <UserWishlist />
              </Tab.Pane>
              <Tab.Pane eventKey="address">
                <UserAddress />
              </Tab.Pane>
              <Tab.Pane eventKey="notify">
                <UserNotification />
              </Tab.Pane>
              <Tab.Pane eventKey="legal">
                <LegalNotice />
              </Tab.Pane>
              <Tab.Pane eventKey="helpcenter">
                <HelpCenter />
              </Tab.Pane>
              <Tab.Pane eventKey="password">
                <ChangePassword />
              </Tab.Pane>
              <Tab.Pane eventKey="logout"></Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
      <Footer />
    </>
  );
}
